import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import withSidebar from '../utils/hocs/withSidebar';
import withAuth from '../utils/hocs/withAuth';
import SCOPE from '../utils/gate/scope';
import withPermission from '../utils/hocs/withPermission';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import MediaLibrary from '../components/views/common/MediaLibrary/MediaLibrary';

function Medias() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('medias.title')}
      hasWhiteWrapper
    >
      <MediaLibrary />
    </PageWrapper>
  );
}

export default withAuth(
  withPermission(
    withSidebar(Medias),
    {
      scopes: [
        SCOPE.get_pla_media,
        SCOPE.get_ownEst_media,
      ],
    },
  ),
);
